import { ActivationRedirectDestination } from "apps/portal/Portal/common/AccountActivation/hooks";

export enum TwoFaActivationType {
  Upgrade,
  GpUser,
}

export function getActivationTypeValues(activationType: TwoFaActivationType | undefined) {
  switch (activationType) {
    case TwoFaActivationType.Upgrade:
      return {
        title: "Upgrade your two-factor authentication to text message",
        subtitle:
          "Your investment manager requires you to upgrade your two-factor authentication to text message.",
        buttonText: "Authenticate using a text message",
        destination: ActivationRedirectDestination.UpgradeTwoFaVerify,
        showHeader: true,
      };
    case TwoFaActivationType.GpUser:
      return {
        title: "Add two-factor authentication",
        subtitle:
          "Your Juniper Square administrator requires two-factor authentication to protect your account",
        buttonText: "Continue",
        destination: ActivationRedirectDestination.NewManagers,
        showHeader: false,
      };
    default:
      return {
        title: "Use text message to set up two-factor authentication",
        subtitle:
          "This is the method that you will use to verify your identity when logging in.",
        buttonText: "Authenticate using a text message",
        destination: ActivationRedirectDestination.VerifyTwoFA,
        showHeader: true,
      };
  }
}

/**
 * Given the `path` query string from the URL, check if the redirect is allowed.
 * @param pathQuery The parsed query string for `path` from the URL. Does not need to be decoded. ex "/contacts" or "%2Fcontacts"
 * @returns boolean indicating if the redirect is allowed.
 */
export function isRedirectAllowed(
  pathQuery: string | null | undefined,
  { allowAbsoluteUrls = true }: { allowAbsoluteUrls: boolean } = { allowAbsoluteUrls: true },
): boolean {
  if (pathQuery) {
    const decodedPath = decodeURIComponent(pathQuery);
    if (allowAbsoluteUrls && decodedPath.includes("://")) {
      // absolute url, convert to a URL and check if it's a jsq domain
      try {
        const url = new URL(decodedPath);
        if (
          url.hostname.endsWith(".junipersquare.com") ||
          url.hostname.endsWith(".junipersquare.us")
        ) {
          return true;
        }
      } catch {
        // invalid URL, not allowed
        return false;
      }
    } else if (decodedPath.startsWith("/") && !decodedPath.startsWith("//")) {
      // relative path, allowed redirect
      return true;
    }
  }

  // all other redirects not allowed
  return false;
}
